var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"keyboard-field"},[_c('div',{staticClass:"keyboard-field__wrapper"},[_c('textarea',_vm._b({ref:"field",staticClass:"field",attrs:{"rows":_vm.$attrs.rows || 4,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"scroll":_vm.setCaretPosition}},'textarea',_vm.$attrs,false)),_vm._v(" "),(_vm.isMobileResolution)?_c('div',{staticClass:"caret",style:({
        height: `${_vm.caretData.height}px`,
        left: `${_vm.caretData.left}px`,
        top: `${_vm.caretData.top}px`,
      })}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }